import { render, staticRenderFns } from "./NothingThereComponent.vue?vue&type=template&id=1c7a256a&"
import script from "./NothingThereComponent.vue?vue&type=script&lang=js&"
export * from "./NothingThereComponent.vue?vue&type=script&lang=js&"
import style0 from "./NothingThereComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports